<template>
  <div>
    <div v-if="isLoading" class="text-center py-5 text-secondary">
      {{ $t("loadingData") }}
    </div>
    <!-- Khu vực hiển thị thông tin chi tiết gói cước -->
    <template v-else-if="subscriptions">
      <h5 class="mb-3">{{ $t("registerServiceInfo") }} -   {{ $t("packageStatus") }}</h5>      
      <!-- Nếu activeSubscription có giá trị -->
        <div v-if="activeSubscription">
          <RemainingDaysBadge :endTime="activeSubscription.endTime" :showBadge="true" />
        </div>

      <template v-if="activeSubscription">
        <div class="px-4 py-3 my-4 border rounded">
        <b-col md="12">
        <h6 style="width:100%;overflow:hidden">
                    <b>{{ activeSubscriptionPlan.name }} </b> 
                    <span class="fs-14">
                        {{ getCustomerPackageQuota() }}
                    </span>
                </h6>
            </b-col>

          <!-- Giao diện mới -->
          <div class="align-items-center mb-3">
              
                <b-row>
                  <b-col md="6">
                    <div class="ml-4">
                    <li v-for="(item, index) in customerPackageItems" :key="index" class="mb-2 fs-14">
                      {{ $t(item.key, { count: item.value }) }}
                    </li>
                  </div>
                  </b-col>
                  <b-col v-if="packageFeatures" md="6">
                    <div v-for="feature in packageFeatures.slice(0, 5)" :key="feature.featureId" class="d-flex align-items-center mb-2">
                      <b-icon icon="check2" class="mr-2 primary-color"/>
                      <span class="fs-14">{{ feature.featureName }}</span>
                    </div>

                    <div v-if="packageFeatures.length > 5" class="d-flex pl-4 primary-color">
                      <a class="primary-color fs-14" style="cursor: pointer;font-size: 15px;margin-left: 5px;" 
                        v-b-tooltip.bottom.hover.html="{ title: featureTooltip, customClass: 'tooltip-class' }">
                          {{$t("viewmore")}} 
                        <i class="fa fa-angle-right" style="font-size: 14px" aria-hidden="true"></i>
                      </a>
                    </div>
                  </b-col>
                </b-row>
            </div>

          <!-- Thời gian sử dụng gói cước -->
          <b-row>
            <b-col md="4" class="fs-14">
              <span class="text-secondary">{{ $t("subCreatedDate") }}:</span> {{
                localDateFormat(activeSubscription.createdTime) }}
            </b-col>
            <b-col md="4" class="fs-14">
              <span class="text-secondary">{{ $t("startDate") }}: </span> {{
                localDateFormat(activeSubscription.startTime) }}
            </b-col>
            <b-col md="4" class="fs-14">
              <span class="text-secondary">{{ $t("expDate") }}: </span> {{ localDateFormat(activeSubscription.endTime)
              }}
            </b-col>
          </b-row>
        </div>
        <div class="pb-4 mb-4" v-if="isManager() || isUserAdmin()">
          <b-dropdown v-if="enableRenewServiceBtn" :text="$t('settingService')" variant="dark" class="mr-3 custom-setting-dropdown" no-caret>
            <b-dropdown-item @click="openSettingModal(SettingType.Quota)">{{ $t("settingQuota") }}</b-dropdown-item>
            <b-dropdown-item @click="openSettingModal(SettingType.Storage)">{{ $t("storageCapacity") }}</b-dropdown-item>
            <b-dropdown-item v-if="hasAIFeature && activeSubscriptionPlan && activeSubscriptionPlan.aiQuota && activeSubscriptionPlan.aiQuota.type !== AiQuotaType.NoUse" @click="openSettingModal(SettingType.AI)">{{ $t("ai_quota") }}</b-dropdown-item>
          </b-dropdown>
          <b-button v-if="enableRenewServiceBtn" variant="outline-primary" class="mr-3"
            v-b-modal:extend-subscription-modal>
            {{ $t("renewService") }}
          </b-button>
          <b-button variant="outline-success" class="mr-3" v-b-modal:upgrade-subscription-modal>
            {{ $t("upgradeService") }}
          </b-button>
          <b-button variant="outline-danger" class="mr-3" @click="onclickCancelService">
            {{ $t("cancelService") }}
          </b-button>
          <!-- <b-button variant="outline-secondary" @click="onClickSendRemindEmail">
            {{ $t("sendServiceRenewReminderEmail") }}
          </b-button> -->
        </div>
      </template>

      <div v-else class="pb-4 mb-4 border-bottom">
        <div class="text-secondary">
          <div class="mb-2">{{ $t("noRegisteredService") }}</div>
          <b-button variant="outline-primary" v-b-modal:register-subscription-modal>{{ $t("registerService")
          }}</b-button>
        </div>
      </div>
      <!-- Khu vực bảng lịch sử đăng ký gói cước -->
      <b-table v-if="historyTableViewMode === 'subscription'" :fields="tableFields" :items="subscriptionsHistory" show-empty class="top-align-table">
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        <!-- Định dạng cột 'Cấu hình'  -->
        <template v-slot:cell(packageInfo)="data">
          <template v-if="data.item.managementType === enumManagementType.CONCURRENT_PARTICIPANT_POOL || (data.item.maxParticipantPool != null && data.item.maxParticipantPool > 0)">
            <span>
              {{ $t("totalParticipantPool") }}: {{ data.item.maxParticipantPool }}
            </span> <br>
            <span class="text-secondary performer-info mt-1">
              {{ $t("type") }}: {{ getManagementTypeLabelLocal(data.item) }}
            </span>
          </template>
          <template v-else>
            <span>
              {{ $t("displayActiveSubConcurrentMeetings", { count: data.item.numberOfConcurrentMeetings }) }}
            </span> <br>
            {{ $t("displayActiveSubMaxParticipants", { count: data.item.meetingConcurrentParticipantsLimit }) }} <br>
            <span class="text-secondary performer-info mt-1">
              {{ $t("type") }}: {{ getManagementTypeLabelLocal(data.item) }}
            </span>
          </template>
        </template>
        <!-- Định dạng cột 'Dung lượng'  -->
        <template v-slot:cell(maxStorageSize)="data">
          <!-- Dung lượng tối đa -->
          <span>
            {{ $t('sum') }}: {{ totalStorageSize(data.item) }}GB <br>
          </span>
          <!-- các thông tin khác (Gói cước, mua thêm, hạn lưu trữ) -->
          <span class="text-secondary performer-info  mt-1">
            {{ $t('baseLimitLabel') }}: {{ bytesToGB(data.item.maxStorageSize, 'GB') }}GB <br>
            {{ $t("add") }}: {{ bytesToGB(data.item.purchasedStorageSize, 'GB') }}GB <br>
            {{ $t("storage") }}: {{ data.item.storageRetentionDays }} {{ $t("days") }} <br>
            {{ $t("type") }}: {{ getStorageTypeLabelLocal(data.item.storageType) }}
          </span>
        </template>
        <!-- Định dạng cột 'Hạn mức AI'  -->
        <template v-slot:cell(aiQuota)="data">
          <template v-if="!data.item.aiQuotaType || data.item.aiQuotaType == AiQuotaType.NoUse">
            <span>--</span>
          </template>
          <template v-else-if="data.item.aiQuotaType == AiQuotaType.Unlimited">
            <span>{{ getAiQuotaTypeLabelLocal(data.item.aiQuotaType) }}</span>
          </template>
          <template v-else>
            <!-- Hạn mức AI tối đa -->
            <span>
              {{ $t('sum') }}: {{ data.item.maxAiMinutes }} {{ $t('minutesCapital') }} <br>
            </span>
            <!-- các thông tin khác (Gói cước, mua thêm, loại) -->
            <span class="text-secondary performer-info mt-1">
              {{ $t('baseLimitLabel') }}: {{ data.item.aiMinutesLimit }} {{ $t('minutesCapital') }} <br>
              {{ $t("add") }}: {{  data.item.purchasedAiMinutes }} {{ $t('minutesCapital') }} <br>
              {{ $t("type") }}: {{ getAiQuotaTypeLabelLocal(data.item.aiQuotaType) }}
            </span>
          </template>
        </template>
        <!-- Định dạng cột Hiệu lực -->
        <template v-slot:cell(period)="data">
          <span>{{ $t('from') }}: {{ localDateFormat(data.item.startTime) }}</span><br>
          <span>{{ $t('to') }}: {{ localDateFormat(data.item.endTime) }}</span>
        </template>
        <!-- Định dạng cột Ghi chú -->
        <template v-slot:cell(packageStatus)="data">
          <div v-if="getLogActionName(data.item.action)">
            <span class="performer-info" style="font-size: 15px">{{ getLogActionName(data.item.action) }}</span>
            <div class="text-secondary performer-info mt-1">
              {{ $t('performedBy') }}:<br>
              {{ data.item.createdByUsername }} <br>
              ({{ data.item.createdByRole }})<br>
              <span v-if="formatCancelledDate(data.item)">{{ $t("day") }}: {{ formatCancelledDate(data.item) }}</span>
            </div>
          </div>
        </template>
      </b-table>
    </template>

    <b-modal id="extend-subscription-modal" :title="$t('renewService')" hide-footer no-close-on-backdrop>
      <ExtendSubscriptionModal :customer-subscription="activeSubscription"
        :meetingConcurrentParticipantsLimit_s="meetingConcurrentParticipantsLimit"
        :numberOfConcurrentMeetings_s="numberOfConcurrentMeetings" @submitted="onSubmitted" />

    </b-modal>

    <b-modal id="register-subscription-modal" :title="$t('registerService')" hide-footer no-close-on-backdrop>
      <RegisterSubscriptionModal :customer-id="id"
        :meetingConcurrentParticipantsLimit_s="meetingConcurrentParticipantsLimit"
        :numberOfConcurrentMeetings_s="numberOfConcurrentMeetings" @submitted="onSubmitted" />
    </b-modal>

    <b-modal id="upgrade-subscription-modal" :title="$t('upgradeService')" hide-footer no-close-on-backdrop>
      <UpgradeSubscriptionModal :customer-subscription="activeSubscription" @submitted="onSubmitted" />
    </b-modal>
    <b-modal id="setting-subscription-modal" :title="settingModalTitle" hide-footer no-close-on-backdrop>
      <!--Popup điều chỉnh dịch vụ cho khách hàng-->
      <SettingSubscriptionModal 
      :customer-detail="customerDetail"
      :customer-subscription="activeSubscription"
        :meetingConcurrentParticipantsLimit_s="meetingConcurrentParticipantsLimit"
        :numberOfConcurrentMeetings_s="numberOfConcurrentMeetings"
        :max-participant-pool_s="maxParticipantPool"
        :has-ai-feature="hasAIFeature"
        :setting-type="settingType"
        @submitted="onSubmitted" />
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.customer-info-text {
  font-size: 17px;
  line-height: 175%;
}

.outline-default {
  border: 1px solid #444444;
}

.fs-14 {
  font-size: 14px;
}

.performer-info {
  font-size: 13px;
  //line-height: 1.3;
}

.outline-default:hover {
  background-color: #444444;
  color: #fff;
}
.table th, .table td {
  padding: 0.25rem !important;
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import _ from "lodash";
import moment from "moment";

 /// Base & Enums
import BaseComponent from '@/components/BaseComponent';
import { getStorageTypeLabel, StorageType } from '@/views/enums/storageType';
import { getAiQuotaTypeLabel, AiQuotaType } from '@/views/enums/aiQuotaType';

import { BvTableFieldArray } from "bootstrap-vue";
import * as util from "@/service/util";
import * as subscriptionUtil from "@/service/subscriptionUtil";
import * as customerService from "@/service/customerService";
import * as subscriptionPlanService from "@/service/subscriptionPlanService";
import ExtendSubscriptionModal from "@/components/customer/subscription/ExtendSubscriptionModal.vue";
import RegisterSubscriptionModal from "@/components/customer/subscription/RegisterSubscriptionModal.vue";
import UpgradeSubscriptionModal from "@/components/customer/subscription/UpgradeSubscriptionModal.vue";
import SettingSubscriptionModal from '@/components/customer/subscription/SettingSubscriptionModal.vue';
import {Status} from "@/views/enums/EnableStatus";
import { SettingType } from '@/views/enums/settingType';
import { featureCode } from '@/views/enums/featureCode';
import { SubscriptionAction, ManagementType } from '@/views/enums/subscriptionAction';
import RemainingDaysBadge from "@/views/customer/details/RemainingDaysBadge.vue";

@Component({
  components: { ExtendSubscriptionModal, RegisterSubscriptionModal, UpgradeSubscriptionModal, SettingSubscriptionModal, RemainingDaysBadge }
})
export default class CustomerDetailsSubscription extends BaseComponent {
  SettingType = SettingType;
  enumManagementType = ManagementType;

  progressBarHeight = "5px";
  id: number = null;
  isLoading = false;
  /// Biến sử dụng để ẩn/hiện nút gia hạn gói cước cuộc họp
  /// chỉ hiển thị khi: Gói cước hiện tại của người dùng có nằm trong danh sách các gói cước của khu vực tương ứng
  enableRenewServiceBtn = false;
  settingType = SettingType.Quota;
  customerDetail = null;
  subscriptions = null;
  activeSubscriptionPlan = null;


  historyTableViewMode: "subscription" | "storage" = "subscription";
  historyTableViewModeOptions = [
    { value: "subscription", text: this.$t("serviceRegisterHistory") },
    { value: "storage", text: this.$t("storageHistory") },
  ];

  enumGetStorageType = getStorageTypeLabel;
  enumGetAiQuotaType = getAiQuotaTypeLabel;
  AiQuotaType = AiQuotaType;

  getStorageTypeLabelLocal(type: number): string {
    if (!type) return "";
    switch (type) {
      case StorageType.Fixed:
        return this.$t("storageType_Fix").toString();
      case StorageType.Session:
        return this.$t("storageType_Session").toString();
      case StorageType.ConcurrentMeeting:
        return this.$t("storageType_Meeting").toString();
      default:
        return "";
    }
  }

  getAiQuotaTypeLabelLocal(type: number): string {
    if (!type) return this.$t("aiQuotaType_NoUse").toString();
    switch (type) {
      case AiQuotaType.Fixed:
        return this.$t("aiQuotaType_Fixed").toString();
      case AiQuotaType.NoReset:
        return this.$t("aiQuotaType_NoReset").toString();
      case AiQuotaType.Unlimited:
        return this.$t("aiQuotaType_Unlimited").toString();
      default:
        return this.$t("aiQuotaType_NoUse").toString();
    }
  }

  getManagementTypeLabelLocal(item: any): string {
    const type = item.managementType || (item.maxParticipantPool > 0 ? ManagementType.CONCURRENT_PARTICIPANT_POOL : ManagementType.CONCURRENT_MEETING);
    switch (type) {
      case ManagementType.CONCURRENT_MEETING:
        return this.$t("numberOfConcurrentMeetings").toString();
      case ManagementType.CONCURRENT_PARTICIPANT_POOL:
        return this.$t("concurrentParticipantPoolOption").toString();
      default:
        return "";
    }
  }

  /// Thời gian lưu trữ của gói cước (hiển thị text)
  customerPackageRetention = '';

  /// Chi tiết các mục thông số trong gói cước
  customerPackageItems = [];

  /// Thông tin cấu hình chức năng của Khách hàng
  packageFeatures = [];

  /// Thông tin các chức năng ở tooltip
  featureTooltip = '';

  ///Ngày hết hạn gói cước
  remainingDays:number = 0;

  subscriptionsHistory: any[] = null;
  tableFields: BvTableFieldArray = [
    {
      key: "id",
      label: "#",
      class: "text-nowrap align-top",
    },
    {
      key: "createdTime",
      label: this.$t("createDate").toString(),
      formatter: value => util.localDateFormat(value),
      class: "text-nowrap align-top",
    },
    {
      key: "subscriptionPlanName",
      label: this.$t("subscriptionPlan").toString(),      
      class: "align-top",
      thStyle: { width: "150px", minWidth: "150px" },
    },
    {
      key: "packageInfo",
      label: 'Cấu hình',      
      class: "align-top",
      thStyle: { width: "200px", minWidth: "150px" },
    },
    {
      key: "maxStorageSize",
      label: this.$t("capacity").toString(),
      formatter: value => `${this.bytesToGB(value)} GB`,      
      class: "text-nowrap align-top",
      thStyle: { width: "200px", minWidth: "150px" },
    },
    {
      key: "aiQuota",
      label: this.$t("ai_quota").toString(),
      class: "text-nowrap align-top",
      thStyle: { width: "200px", minWidth: "150px" },
    },
    {
      key: "period",
      label: this.$t('period').toString(),
      class: "text-nowrap align-top",
    },
    {
      key: "packageStatus",
      label: this.$t('note').toString(),
      class: "text-nowrap align-top",
      thStyle: { width: "200px", minWidth: "150px" },
    }
  ];
  storageHistory: any[] = null;
  storageHistoryTableFields: BvTableFieldArray = [
    {
      key: "id",
      label: "#"
    },
    {
      key: "appliedDate",
      label: this.$t("datetime").toString(),
      formatter: value => util.localDateFormat(value)
    },
    {
      key: "storage",
      label: this.$t("storageGb").toString(),
    },
  ];

  mounted() {
    this.id = +this.$route.params.id || null;
    this.fetchSubscriptions();

  }
  meetingConcurrentParticipantsLimit = 0;
  numberOfConcurrentMeetings = 0;
  maxParticipantPool = 0;
  capacity = 0; 
  async fetchSubscriptions() {
    try {
      this.isLoading = true;
      // Gọi song song 3 API đầu tiên để tăng hiệu năng
      const [customerDetail, subscriptions, subscriptionHistory, storageHistory] = await Promise.all([
        customerService.getDetails(this.id),
        subscriptionPlanService.getCustomerSubscription(this.id),
        subscriptionPlanService.getCustomerSubscriptionHistoryList(this.id),
        subscriptionPlanService.getCustomerStorageSubscriptionHistoryList(this.id),
      ]);
      // Gán dữ liệu
      this.customerDetail = customerDetail;
      this.subscriptions = subscriptions;
      this.subscriptionsHistory = subscriptionHistory;

      this.storageHistory = storageHistory;
      // Nếu có subscription đang hoạt động thì lấy chi tiết plan
      if (this.activeSubscription) {
        const { subscriptionPlanId } = this.activeSubscription;
        this.activeSubscriptionPlan = await subscriptionPlanService.getPackageDetail(subscriptionPlanId);
        // 
        //this.customerPackageItems = await customerService.getCustomerFeature(this.id);
        const customPack = await customerService.getCustomerFeature(this.id);
        //sortedFeatures:Sắp xếp mảng theo featureId tăng dần
        this.packageFeatures = this.sortedFeatures(customPack.features.filter(feature => feature.isActive ===  Status.ENABLE));

      try {
          const allSubscriptionUser = await subscriptionPlanService.getPlans();
          this.enableRenewServiceBtn = allSubscriptionUser.some(
            it => it.code === this.activeSubscriptionPlan?.code
          );
        } catch (e) {
          this.enableRenewServiceBtn = false;
        }
      this.updateProps();
      } else {


        this.meetingConcurrentParticipantsLimit = 100;
      }
    } catch (e) {
      this.toastError(e); // Hàm xử lý hiển thị lỗi tùy bạn định nghĩa
    } finally {
      this.isLoading = false;
    }

  }
  /// Lấy thông tin hạn mức gói cước của KH
  getCustomerPackageQuota() {

    /// Lấy thông tin gói cước
    const plan = this.activeSubscriptionPlan;

    /// Kiểm tra dữ liệu đầu vào
    if (!this.customerDetail || !plan) return;

    /// Lấy nhãn dung lượng lưu trữ
    const storageLabel = util.getStorageLabel(
      plan,
      this.$t("storage"),
      this.$t("meeting"),
      this.$t("days").toString().toLowerCase(),
      this.customerDetail.maxStorageSizeAfterPurchase
    );

    /// Lấy nhãn hạn mức AI
    if (plan?.aiQuota && this.hasAIFeature) {
      const aiLabel = util.getQuotaAILabel(
        plan,
        this.$t("ai_quota").toString(),
        this.$t("minutesCapital").toString().toLowerCase(),
        this.$t("aiQuotaType_Unlimited").toString(),
        this.$t("aiQuotaType_NoReset").toString(),
        this.$t("aiQuotaType_Fixed").toString(),
        this.$t("aiQuotaType_NoUse").toString(),
        this.customerDetail.aiQuota?.purchasedMinutes
      );
      return `${storageLabel} ${aiLabel}`;
    }

    return storageLabel;
  }

  /// Cập nhật các props của page
  updateProps() {

      ///-----------------------------------------c
      
    this.customerPackageItems = subscriptionUtil.buildCustomerPackageItems(this.activeSubscription,this.activeSubscriptionPlan);

    ///-----------------------------------------
    // Tooltip các chức năng
    if (this.activeSubscriptionPlan?.features) {
      this.featureTooltip = util.generateFeatureTooltip(this.activeSubscriptionPlan.features);
    }
    ///-----------------------------------------

    // Gán dữ liệu số cuộc họp đồng thời vs số lượng người tham gia
    this.meetingConcurrentParticipantsLimit = this.activeSubscription.meetingConcurrentParticipantsLimit ?? this.activeSubscriptionPlan.maximumNumberOfParticipantsInMeeting;
    this.capacity = this.activeSubscription.maxStorageSize ?? 1000;
    this.numberOfConcurrentMeetings = this.activeSubscription.numberOfConcurrentMeetings ?? this.activeSubscriptionPlan.numberOfConcurrentMeetings;
    this.maxParticipantPool = this.activeSubscription.maxParticipantPool ?? this.activeSubscriptionPlan.maxParticipantPool ?? 0;
  }
  get activeSubscription() {
    return this.subscriptions?.find(it => it.isActive);
  }

  get hasAIFeature(): boolean {
    const hasAi = this.packageFeatures?.some(
      f => f.featureCode === featureCode.ALLOW_SUMMARY || f.featureCode === featureCode.ALLOW_LIVECAPTION
    ) ?? false;
    const aiQuotaType = this.customerDetail?.aiQuota?.aiQuotaType;
    return hasAi && aiQuotaType !== undefined && aiQuotaType !== null && aiQuotaType !== AiQuotaType.NoUse;
  }

  get settingModalTitle(): string {
    switch (this.settingType) {
      case SettingType.Quota:
        if (this.activeSubscriptionPlan?.managementType === ManagementType.CONCURRENT_PARTICIPANT_POOL) {
          return this.$t('concurrentParticipantPoolOption').toString();
        }
        return this.$t('settingQuota').toString();
      case SettingType.Storage:
        return this.$t('storageCapacity').toString();
      case SettingType.AI:
        return this.$t('purchaseAiQuotaTitle').toString();
      default:
        return this.$t('settingService').toString();
    }
  }

  async onclickCancelService() {

    const modalMessage = this.$t("cancelServiceConfirm").toString();
    const confirmSend = await this.$bvModal.msgBoxConfirm(modalMessage, {
      okVariant: 'danger',
      okTitle: this.$t("yes").toString(),
      cancelTitle: this.$t("no").toString(),
    });

    if (confirmSend) {
      try {
        this.showLoading();
        await customerService.cancelService(this.id);
        this.toastSuccessDelay(this.$t("cancelServiceSuccess").toString());
        await this.fetchSubscriptions();
        this.$emit("refresh");
      } catch (e) {
        
        this.toastError(e);


      } finally {
        this.hideLoading();
      }
    }
  }

  async onSubmitted() {
    await this.fetchSubscriptions();
    this.$emit("refresh");
  }

  openSettingModal(type: SettingType) {
    this.settingType = type;
    this.$bvModal.show('setting-subscription-modal');
  }

  async onClickSendRemindEmail() {
    const modalMessage = this.$t("sendServiceRenewReminderEmailConfirm").toString();
    const confirmSend = await this.$bvModal.msgBoxConfirm(modalMessage, {
      okVariant: 'primary',
      okTitle: this.$t("yes").toString(),
      cancelTitle: this.$t("no").toString(),
    });

    if (confirmSend) {
      try {
        this.showLoading();
        await customerService.sendSubscriptionReminderEmail(this.activeSubscription.id);
        this.toastSuccessDelay(this.$t("sendServiceRenewReminderEmailSuccessful").toString());

      } catch (e) {
        this.toastError(e);

      } finally {
        this.hideLoading();
      }
    }
  }
  /**
   * Tổng dung lượng lưu trữ (mua thêm + gói cước)
   */
  totalStorageSize(item: any) {
    if (!item) return 0;
    const totalBytes = item.maxStorageSizeAfterPurchase ?? util.getMaxStorage(item.maxStorageSize ?? 0, item.purchasedStorageSize ?? 0);
    return util.bytesToGB(totalBytes);
  }
  /**
   * Định dạng thông tin ngày hủy của gói dịch vụ
   */
  formatCancelledDate(item: any) {
    if (item && item.action === SubscriptionAction.CANCEL && item.cancelledAt) {
      return moment(item.cancelledAt).format('DD/MM/YYYY - HH:mm:ss');
    }
    return '';
  }
  /**
   * Lấy tên hành động tương ứng với log
   */
  getLogActionName(action: number) {
    switch (action) {
      case SubscriptionAction.REGISTER:
        return this.$t('registerNew').toString();
      case SubscriptionAction.RENEW:
        return this.$t('renew').toString();
      case SubscriptionAction.CANCEL:
        return this.$t('cancelService').toString();
      case SubscriptionAction.CONFIG:
        return this.$t('changeInfo').toString();
      default:
        return '';
    }
  }
  /**
   * Chuyển đổi đơn vị dung lượng byte sang GB
   */
  bytesToGB(sizeInBytes) {
    return util.bytesToGB(sizeInBytes, true, 2);
  }
}
</script>
